import { searchRoutes } from '../../constants';

export const tabs = {
    GAINED_AGENTS: 0,
    LOST_AGENTS: 1,
    OFFICE_DETAILS: 2
};

export const initialTabState = {
    shouldShowAdditionalInfo: false,
    isFooterDisabled: false,
    listingStatus: {
        label: ''
    }
};

const initialTabsState = {
    [tabs.GAINED_AGENTS]: initialTabState,
    [tabs.LOST_AGENTS]: initialTabState,
    [tabs.OFFICE_DETAILS]: initialTabState
};

export const initialBreakdownState = Object.freeze({
    selectedBreakdownTab: tabs.GAINED_AGENTS,
    tabsByRoute: {
        [searchRoutes.agentsGainedBreakdown]: initialTabsState,
        [searchRoutes.officeListBreakdown]: initialTabsState,
    },
});

export const OFFICE_BRKDWN_GROWTH_TAB_INDEX = 2;
